import { render, staticRenderFns } from "./SugestoesCompra.vue?vue&type=template&id=56652820&scoped=true"
import script from "./SugestoesCompra.vue?vue&type=script&lang=js"
export * from "./SugestoesCompra.vue?vue&type=script&lang=js"
import style0 from "./SugestoesCompra.vue?vue&type=style&index=0&id=56652820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56652820",
  null
  
)

export default component.exports